export default __webpack_public_path__ + "static/media/sentiment-negative.279aba47.svg";